import { render, staticRenderFns } from "./rule-toast.vue?vue&type=template&id=5f357d23&scoped=true&"
var script = {}
import style0 from "./rule-toast.vue?vue&type=style&index=0&id=5f357d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f357d23",
  null
  
)

export default component.exports